import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PRICE_SELECTED, START } from 'pu-data/QuoteSteps';
import ProductCartForm from 'pu-react/components/ProductCart';
import { addErrors, hideValidatorErrorMessages, showValidatorErrorMessages, validator } from 'us_pcb_assembly/store/slice';

const Cart = () => {
  const dispatch = useDispatch();
  const [unitPrice, setUnitPrice] = useState(0);
  const [totalPrice, setTotalPrice] = useState(null);
  const [quantity, setQuantity] = useState(null);
  const [leadTime, setLeadTime] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  const {
    quote,
    quoteStep,
    parameters,
    parametersChanged,
  } = useSelector((state) => state.usAssembly);

  useEffect(() => {
    const { row_selected, column_selected, supplier_selected } = parameters;

    const isValid = (v) => v !== null && v !== undefined && v !== '';

    if (!isValid(row_selected) || !isValid(column_selected) || !isValid(supplier_selected)) {
      setQuantity(null);
      setLeadTime(null);
      setUnitPrice(null);
      setTotalPrice(null);
      setSelectedSupplier(null);
      return;
    }

    if (quote && quote.line_items) {
      const lineItem = quote.line_items.find((li) => li.product_key === supplier_selected);

      if (lineItem && lineItem.quantities && lineItem.lead_times && lineItem.pricing) {
        const quantity = lineItem.quantities[row_selected]
        let unitPrice = parseFloat(lineItem.pricing[row_selected][column_selected]) / parseFloat(quantity);
        let totalPrice = accounting.toFixed(unitPrice * parseFloat(quantity), 2);

        unitPrice = accounting.toFixed(unitPrice, 2);
        totalPrice = accounting.toFixed(totalPrice, 2);

        setQuantity(quantity);
        setLeadTime(lineItem.lead_times[column_selected]);
        setUnitPrice(accounting.formatMoney(unitPrice), { precision: 2 });
        setTotalPrice(accounting.formatMoney(totalPrice));
        setSelectedSupplier(supplier_selected);
      }
    }
  }, [quote, parameters])

  const properties = [
    { label: 'Qty:', value: quantity },
    { label: 'Lead Time:', value: leadTime && `${leadTime} ${selectedSupplier === 'assembly-mx' ? 'weeks' : 'days'}` },
  ];

  const onAddToCart = () => {
    if (quoteStep === START || totalPrice <= 0) {
      dispatch(addErrors('Please select some product before adding to cart'));
      return
    } else if (quoteStep === PRICE_SELECTED) {
      const fields = ['Zip file', 'Part Number', 'Revision']
      const invalidFields = fields.filter((field) => !validator.fieldValid(field))

      if (invalidFields.length > 0 || !validator.allValid()) {
        const errors = invalidFields.map((field) => `Please add the board ${field}`)
        if (errors.length) dispatch(addErrors(errors))

        dispatch(showValidatorErrorMessages(invalidFields))
        return
      } else if (parametersChanged) {
        dispatch(addErrors('One or more parameters have changed. Please get a new quote'));
        return
      }
    }

    dispatch(hideValidatorErrorMessages())
    $('#quote_form').submit()
  }


  return (
    <div>
      <ProductCartForm
        quoteStep={quoteStep}
        properties={properties}
        unitPrice={unitPrice}
        totalPrice={totalPrice}
        parametersChanged={parametersChanged}
        onAddToCart={onAddToCart} />
    </div>
  );
};

export default Cart;